<template>
    <div class="section text-center pt-3" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <template v-else-if="application.id">
        <div class="section pt-0 mt-0">
            <div class="listed-detail mt-0">
                <h3 class="text-center mt-0 mal-text custom-title">{{ application.program_title }}</h3>
                <p class="text-center text-muted small mb-0 mal-text">വിവരങ്ങൾ എഡിറ്റ് ചെയ്ത് അപ്ഡേറ്റ് ചെയ്യുക</p>
            </div>
        </div>

        <!-- VO comments the unit must address -->
        <div class="section pt-1" v-if="application.verification && application.verification.notes">
            <div class="card" style="border-left:4px solid #d9534f;">
                <div class="card-body mal-text" style="padding:12px 14px;">
                    <b class="text-danger">{{ application.verification.status === 'not_verified' ? 'Not Verified' : 'Edit Requested' }}</b>
                    <small class="text-muted" v-if="application.verification.officer_name"> · {{ application.verification.officer_name }}</small>
                    <p class="mb-0 mt-1 small"><b>Note:</b> {{ application.verification.notes }}</p>
                </div>
            </div>
        </div>

        <div class="section pt-1" v-if="application.relief">
            <div class="card">
                <div class="card-body mal-text">
                    <h6 class="text-primary mb-2">കുടുംബ വിവരങ്ങൾ</h6>
                    <label class="field-label">കുടുംബ നാഥന്റെ പേര്</label>
                    <input v-model="form.family_head_name" type="text" class="form-control mb-1" :disabled="isFieldLocked('family_head_name')" />
                    <p v-if="fieldNote('family_head_name')" class="field-vo-note mal-text">{{ fieldNote('family_head_name') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">ലിംഗം</label>
                    <select v-model="form.family_head_gender" class="form-select mb-1" :disabled="isFieldLocked('family_head_gender')">
                        <option value="Male">പുരുഷൻ</option>
                        <option value="Female">സ്ത്രീ</option>
                    </select>
                    <p v-if="fieldNote('family_head_gender')" class="field-vo-note mal-text">{{ fieldNote('family_head_gender') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">വയസ്സ്</label>
                    <input v-model="form.family_head_age" type="number" class="form-control mb-1" :disabled="isFieldLocked('family_head_age')" />
                    <p v-if="fieldNote('family_head_age')" class="field-vo-note mal-text">{{ fieldNote('family_head_age') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">വീട്ട് പേര്</label>
                    <input v-model="form.family_head_surname" type="text" class="form-control mb-2" />

                    <label class="field-label">ഫോൺ</label>
                    <input v-model="form.family_contact" type="tel" class="form-control mb-1" :disabled="isFieldLocked('family_contact')" />
                    <p v-if="fieldNote('family_contact')" class="field-vo-note mal-text">{{ fieldNote('family_contact') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">താമസിക്കുന്ന സ്ഥലം</label>
                    <input v-model="form.family_place" type="text" class="form-control mb-1" :disabled="isFieldLocked('family_place')" />
                    <p v-if="fieldNote('family_place')" class="field-vo-note mal-text">{{ fieldNote('family_place') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">ഉൾപ്പെടുത്താനുള്ള കാരണം</label>
                    <textarea v-model="form.family_reason_to_include" rows="2" class="form-control mb-1" :disabled="isFieldLocked('family_reason_to_include')"></textarea>
                    <p v-if="fieldNote('family_reason_to_include')" class="field-vo-note mal-text">{{ fieldNote('family_reason_to_include') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">സകാത്ത് അർഹത</label>
                    <select v-model="form.zakath_eligible" class="form-select mb-1" :disabled="isFieldLocked('zakath_eligible')">
                        <option value="Yes">അതെ</option>
                        <option value="No">ഇല്ല</option>
                    </select>
                    <p v-if="fieldNote('zakath_eligible')" class="field-vo-note mal-text">{{ fieldNote('zakath_eligible') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">കുടുംബത്തിലെ ആകെ എണ്ണം</label>
                    <input v-model="form.family_members_count" type="number" class="form-control mb-1" :disabled="isFieldLocked('family_members_count')" />
                    <p v-if="fieldNote('family_members_count')" class="field-vo-note mal-text">{{ fieldNote('family_members_count') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">യാതീം എണ്ണം</label>
                    <input v-model="form.orphan_count" type="number" class="form-control mb-1" :disabled="isFieldLocked('orphan_count')" />
                    <p v-if="fieldNote('orphan_count')" class="field-vo-note mal-text">{{ fieldNote('orphan_count') }}</p>
                    <div class="mb-2"></div>

                    <label class="field-label">വിധവ എണ്ണം</label>
                    <input v-model="form.widow_count" type="number" class="form-control mb-1" :disabled="isFieldLocked('widow_count')" />
                    <p v-if="fieldNote('widow_count')" class="field-vo-note mal-text">{{ fieldNote('widow_count') }}</p>
                </div>
            </div>
        </div>

        <div class="section pt-0" v-if="formFields.length">
            <div class="card">
                <div class="card-body mal-text">
                    <h6 class="text-primary mb-2">പദ്ധതി അപേക്ഷ വിവരങ്ങൾ</h6>
                    <div class="form-group basic" v-for="(field, index) in formFields" :key="field.key">
                        <div class="input-wrapper">
                            <label class="field-label mal-text">
                                {{ index + 1 }}. {{ field.label_ml }}
                                <span v-if="field.required || effectiveGroupKey(field)" class="text-danger">*</span>
                            </label>

                            <input v-if="field.type === 'text'" type="text" class="form-control mb-1"
                                v-model="form.extra[field.key]" :disabled="isFieldLocked('extra_' + field.key)" />

                            <textarea v-else-if="field.type === 'textarea'" class="form-control mb-1" rows="3"
                                v-model="form.extra[field.key]" :disabled="isFieldLocked('extra_' + field.key)"></textarea>

                            <select
                                v-else-if="field.type === 'select'"
                                class="form-select mb-1"
                                v-model="form.extra[field.key]"
                                :disabled="isFieldLocked('extra_' + field.key)"
                            >
                                <option value="" disabled hidden>തിരഞ്ഞെടുക്കുക</option>
                                <option v-for="opt in field.options || []" :key="opt" :value="opt">{{ opt }}</option>
                            </select>

                            <div v-else-if="field.type === 'yes_no'" class="sneha-option-group">
                                <label
                                    v-for="opt in yesNoOptions"
                                    :key="field.key + '_' + opt.value"
                                    class="sneha-option-tile"
                                    :class="{ selected: form.extra[field.key] === opt.value }"
                                >
                                    <input
                                        type="radio"
                                        class="sneha-option-input"
                                        :name="'extra_' + field.key"
                                        :value="opt.value"
                                        v-model="form.extra[field.key]"
                                        :disabled="isFieldLocked('extra_' + field.key)"
                                    />
                                    <span class="sneha-option-label">{{ opt.label }}</span>
                                </label>
                            </div>

                            <div v-else-if="field.type === 'checkbox'" class="sneha-option-group sneha-option-group--stack">
                                <label
                                    v-for="opt in field.options || []"
                                    :key="field.key + '_' + opt"
                                    class="sneha-option-tile sneha-option-tile--check"
                                    :class="{ selected: isCheckboxChecked(field.key, opt) }"
                                >
                                    <input
                                        type="checkbox"
                                        class="sneha-option-input"
                                        :value="opt"
                                        :checked="isCheckboxChecked(field.key, opt)"
                                        :disabled="isFieldLocked('extra_' + field.key)"
                                        @change="toggleCheckbox(field.key, opt, $event)"
                                    />
                                    <span class="sneha-option-label">{{ opt }}</span>
                                </label>
                            </div>

                            <input
                                v-if="field.type === 'select' && (field.extra_field_options || []).includes(form.extra[field.key])"
                                type="text"
                                class="form-control mt-2"
                                v-model="form.extra[field.key + '__extra']"
                                :placeholder="field.extra_field_label || ''"
                                :disabled="isFieldLocked('extra_' + field.key)"
                            />

                            <p v-if="fieldNote('extra_' + field.key)" class="field-vo-note mal-text">{{ fieldNote('extra_' + field.key) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section pt-0 pb-4">
            <button type="button" class="btn btn-primary w-100" style="border-radius:10px;"
                :disabled="saving" @click="save">
                <span v-if="saving" class="spinner-border spinner-border-sm me-1"></span>
                അപ്ഡേറ്റ് ചെയ്യുക
            </button>
        </div>
    </template>

    <div class="section pt-3" v-else-if="!loading">
        <div class="listed-detail mt-0">
            <h4 class="text-center mt-0 mal-text">അപേക്ഷ കണ്ടെത്തിയില്ല</h4>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "@/services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: "SnehaSparshamApplicationEdit",
    components: { AlertModel },
    data() {
        return {
            loading: true,
            saving: false,
            application: {},
            form: { extra: {} },
            alert_type: "",
            alert_message: "",
            yesNoOptions: [
                { value: "Yes", label: "അതെ" },
                { value: "No", label: "ഇല്ല" },
            ],
        };
    },
    computed: {
        formFields() {
            return Array.isArray(this.application.form_fields) ? this.application.form_fields : [];
        },
    },
    mounted() {
        if (!this.$store.state.auth.user) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("അപേക്ഷ എഡിറ്റ്");
        this.load();
    },
    methods: {
        // A field the VO ticked "Verified" is confirmed correct and locked from re-editing;
        // an unticked field (or one the VO's checklist never covered) stays editable.
        isFieldLocked(key) {
            const ticks = (this.application.verification && this.application.verification.field_ticks) || {};
            return !!ticks[key];
        },
        // The VO's note explaining why a field needs correction, if one was left.
        fieldNote(key) {
            const notes = (this.application.verification && this.application.verification.field_notes) || {};
            return notes[key] || '';
        },
        isCheckboxChecked(fieldKey, opt) {
            const arr = this.form.extra[fieldKey];
            return Array.isArray(arr) && arr.indexOf(opt) !== -1;
        },
        toggleCheckbox(fieldKey, opt, event) {
            const arr = Array.isArray(this.form.extra[fieldKey]) ? [...this.form.extra[fieldKey]] : [];
            const idx = arr.indexOf(opt);
            if (event.target.checked) {
                if (idx === -1) arr.push(opt);
            } else if (idx !== -1) {
                arr.splice(idx, 1);
            }
            this.form.extra[fieldKey] = arr;
        },
        isFieldAnswered(field) {
            const value = this.form.extra[field.key];
            if (field.type === "checkbox") {
                return Array.isArray(value) && value.length > 0;
            }
            return value !== null && value !== undefined && value !== "";
        },
        // Same either/or Required Group + Required Set convention as the create form.
        effectiveGroupKey(field) {
            return field.required_group || field.required_set || "";
        },
        fieldsInGroup(groupKey) {
            return this.formFields.filter((f) => this.effectiveGroupKey(f) === groupKey);
        },
        setsInGroup(groupKey) {
            const bySet = {};
            const order = [];
            this.fieldsInGroup(groupKey).forEach((f) => {
                const setKey = f.required_set || "__field__" + f.key;
                if (!bySet[setKey]) {
                    bySet[setKey] = [];
                    order.push(setKey);
                }
                bySet[setKey].push(f);
            });
            return order.map((setKey) => bySet[setKey]);
        },
        orderRangeLabel(fieldsList) {
            const idxs = fieldsList.map((f) => this.formFields.indexOf(f) + 1).sort((a, b) => a - b);
            if (!idxs.length) return "";
            const contiguous = idxs.every((v, i) => i === 0 || v === idxs[i - 1] + 1);
            return contiguous && idxs.length > 1 ? idxs[0] + "-" + idxs[idxs.length - 1] : idxs.join(", ");
        },
        groupRequirementMessage(groupKey) {
            const parts = this.setsInGroup(groupKey).map((setFields) => "(" + this.orderRangeLabel(setFields) + ")");
            return parts.join(" അല്ലെങ്കിൽ ") + " ഇവയിൽ ഏതെങ്കിലും ഒരു സെറ്റ് പൂർണമായി ഫിൽ ചെയ്യുക!";
        },
        validateExtraFields() {
            const checkedGroups = [];
            for (const field of this.formFields) {
                const groupKey = this.effectiveGroupKey(field);
                if (groupKey) {
                    if (checkedGroups.indexOf(groupKey) !== -1) continue;
                    checkedGroups.push(groupKey);
                    const anySetComplete = this.setsInGroup(groupKey).some((setFields) =>
                        setFields.every((f) => this.isFieldAnswered(f))
                    );
                    if (!anySetComplete) {
                        this.showWarning(this.groupRequirementMessage(groupKey));
                        return false;
                    }
                    continue;
                }
                if (!field.required) continue;
                if (!this.isFieldAnswered(field)) {
                    this.showWarning((field.label_ml || field.key) + " ഫിൽ ചെയ്യുക!");
                    return false;
                }
            }
            return true;
        },
        showWarning(message) {
            this.alert_type = "Warning";
            this.alert_message = message || "ക്ഷമിക്കണം. വീണ്ടും ശ്രമിക്കുക.";
            this.$refs.alert_model.openModel();
        },
        load() {
            this.loading = true;
            UserService.authPostRequest("get-sneha-sparsham-application", {
                application_id: parseInt(this.$route.params.application_id, 10),
            }).then((response) => {
                this.loading = false;
                if (response.data.status === "success") {
                    this.application = response.data.data || {};
                    const r = this.application.relief || {};
                    const rawExtra = this.application.extra_data || {};
                    const extra = {};
                    (this.application.form_fields || []).forEach((field) => {
                        const saved = rawExtra[field.key];
                        if (field.type === "checkbox") {
                            extra[field.key] = Array.isArray(saved) ? [...saved] : [];
                        } else {
                            extra[field.key] = saved !== undefined && saved !== null ? saved : "";
                        }
                        if ((field.extra_field_options || []).length) {
                            extra[field.key + "__extra"] = rawExtra[field.key + "__extra"] || "";
                        }
                    });
                    this.form = {
                        family_head_name: r.family_head_name,
                        family_head_gender: r.family_head_gender,
                        family_head_age: r.family_head_age,
                        family_head_surname: r.family_head_surname,
                        family_contact: r.family_contact,
                        family_place: r.family_place,
                        family_reason_to_include: r.family_reason_to_include,
                        zakath_eligible: r.zakath_eligible,
                        family_members_count: r.family_members_count,
                        orphan_count: r.orphan_count,
                        widow_count: r.widow_count,
                        extra: extra,
                    };
                }
            }).catch(() => { this.loading = false; });
        },
        save() {
            if (!this.validateExtraFields()) return;
            this.saving = true;
            const payload = {
                application_id: parseInt(this.$route.params.application_id, 10),
                ...this.form,
                extra_data: this.form.extra,
            };
            delete payload.extra;
            UserService.authPostRequest("update-sneha-sparsham-application", payload).then(
                (response) => {
                    this.saving = false;
                    this.alert_type = response.data.status === "success" ? "Success" : "Warning";
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    if (response.data.status === "success") {
                        setTimeout(() => this.$router.back(), 1200);
                    }
                },
                () => { this.saving = false; }
            );
        },
    },
};
</script>

<style scoped>
.field-label { font-size: 15px; font-weight: 700; color: #1a418c; margin-bottom: 5px; display: block; line-height: 1.35; }
.form-control, .form-select { font-size: 15px; }
.form-control:disabled, .form-select:disabled { background: #f1f3f7; color: #94a3b8; }
.field-vo-note {
    font-size: 13px;
    color: #d9534f;
    background: #fff5f5;
    border-radius: 6px;
    padding: 4px 8px;
    margin: 2px 0 0;
}

.sneha-option-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 6px;
    margin-bottom: 6px;
}

.sneha-option-group--stack {
    flex-direction: column;
}

.sneha-option-tile {
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    flex: 1 1 calc(50% - 10px);
}

.sneha-option-group--stack .sneha-option-tile {
    flex: 1 1 auto;
}

.sneha-option-tile.selected {
    border-color: #0d6efd;
    background: #eef4ff;
}

.sneha-option-input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
    pointer-events: none;
}

.sneha-option-label {
    width: 100%;
    color: #212529;
    font-size: 14px;
    line-height: 1.3;
    pointer-events: none;
}

.sneha-option-tile--check.selected .sneha-option-label::before {
    content: "✓ ";
    color: #0d6efd;
    font-weight: 700;
}
</style>
